import React from 'react';
import { CircularProgress, Typography } from '@material-ui/core';
import { LoadMoreContainer, StyledReplayIcon } from './LoadMoreCard.styles';

interface LoadMoreCardProps {
  onClick: () => void;
  isLoading?: boolean;
}

const LoadMoreCard = ({ onClick, isLoading = false }: LoadMoreCardProps) => {
  return (
    <LoadMoreContainer
      onClick={isLoading ? undefined : onClick}
      aria-disabled={isLoading}
      aria-busy={isLoading}
    >
      {isLoading ? (
        <CircularProgress size={150} color="primary" />
      ) : (
        <StyledReplayIcon color="primary" />
      )}
      <Typography variant="h5" color="primary">
        {isLoading ? 'Loading...' : 'Load more'}
      </Typography>
    </LoadMoreContainer>
  );
};

export default LoadMoreCard;
